export default "__VITE_ASSET__HmwNidTg__"